import { getLocationBySlug } from "@/data/locations";
import { getTown, getStateHub } from "@/data/towns";
import { stateGeoDescription, townGeoMetadata, regionGeoMetadata } from "./geoContent";
import { getServiceConfig } from "@/data/serviceLocations";
import { pageHead, unavailableHead } from "./seoPolicy";
import { redirect } from "@tanstack/react-router";

// Preserve retired public URLs before validation or optional content fetching.
const legacyLocationSlugs = new Map([
  ["boston-ma", "metrowest-ma"],
  ["hartford-ct", "hartford-county-ct"],
  ["washington-dc", "loudoun-county-va"],
]);

export function redirectLegacyLocation(slug: string) {
  const destination = legacyLocationSlugs.get(slug);
  if (!destination) return;
  throw redirect({
    to: "/locations/$slug",
    params: { slug: destination },
    search: true,
    statusCode: 301,
    replace: true,
  });
}

export function resolveGeoRoute(segments: string[]) {
  const [a, b, c] = segments;
  if (!a || segments.length > 3) return null;
  const hub = getStateHub(a);
  if (segments.length === 1) {
    if (hub) return { title: `Fence Installation in ${hub.name} | Modern Fence Install`, description: stateGeoDescription(hub.name) };
    const region = getLocationBySlug(a);
    return region ? regionGeoMetadata(region) : null;
  }
  if (!b) return null;
  if (hub) {
    const town = getTown(a, b);
    if (!town) return null;
    const region = getLocationBySlug(town.parentRegionSlug);
    if (!region) return null;
    if (segments.length === 2) return townGeoMetadata(town, region);
    const service = c ? getServiceConfig(c) : undefined;
    return service ? townGeoMetadata(town, region, service) : null;
  }
  if (segments.length !== 2) return null;
  const region = getLocationBySlug(a);
  const service = getServiceConfig(b);
  return region && service ? regionGeoMetadata(region, service) : null;
}

export function geoRouteHead(segments: string[], valid: boolean) {
  const seo = valid ? resolveGeoRoute(segments) : null;
  return seo ? pageHead(seo.title, seo.description, `/locations/${segments.join("/")}`) : unavailableHead();
}